import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

class GenderApi {
  static getGender() {

    const request = new Request(`${apiUrl}/content/gender_list`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }
}

export default GenderApi;
